  //Makes an asynchronous call to the server to delete a photo
  //uri must be a full url including id. Example: https://photos/1112
  window.deletePhotoFromServer = function(uri) {
    var fd = new FormData();
    var xhr = new XMLHttpRequest();
    xhr.open('DELETE', uri, true);
    xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    xhr.send(fd);
  };